// src/services/queryClient.js
//
// Single shared QueryClient instance. Pulled out of index.js so other
// modules (e.g. auth.js's logout()) can reach in and clear the in-memory
// cache directly — clearing localStorage alone doesn't touch this, and
// logout→login happens via SPA navigation (no page reload), so the old
// in-memory cache would otherwise survive a fresh login untouched.
import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      gcTime: Infinity,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  },
});
